export default {
  methods: {
    addEventListener({ eventName, callback }) {
      console.log(Object.prototype.toString.call(callback));
      if (Object.prototype.toString.call(callback) === "[object Function]") {
        let addEventListener = window.addEventListener || window.attachEvent;
        let messageEvent = window.addEventListener
          ? eventName
          : `on${eventName}`;
        addEventListener(messageEvent, callback, false);
      }
    },
    removeEventListener({ eventName, callback }) {
      if (Object.prototype.toString.call(callback) === "[object Function]") {
        let removeEventListener =
          window.removeEventListener || window.detachEvent;
        let messageEvent = window.addEventListener
          ? eventName
          : `on${eventName}`;
        removeEventListener(messageEvent, callback, false);
      }
    }
  }
};
